import LayoutBlank from '@/layout/LayoutBlank'

export default [{
  path: '/Assist',
  component: LayoutBlank,
  children: [{
    path: 'Login',
    component: () => import('@/components/Assist/Login')
  }]
}]
